/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationQueryKey,
  ServiceOperationUseMutationOptions,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  Mutation,
  MutationCache,
  MutationState,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseMutationResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface VoiceSettingsService {
  /**
   * @summary Get
   * @description Get complete voice settings for an office with all subsections
   */
  getVoiceSettings: {
    /**
     * @summary Get
     * @description Get complete voice settings for an office with all subsections
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<GetVoiceSettingsSchema, GetVoiceSettingsParameters, TMeta, TSignal>
        | QueryFnOptionsByParameters<GetVoiceSettingsParameters, TMeta, TSignal>,
      client?: (
        schema: GetVoiceSettingsSchema,
        options: {
          parameters: GetVoiceSettingsParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<GetVoiceSettingsData, GetVoiceSettingsError>>
    ): Promise<RequestFnResponse<GetVoiceSettingsData, GetVoiceSettingsError>>;
    /**
     * @summary Get
     * @description Get complete voice settings for an office with all subsections
     */
    getQueryKey(
      parameters: DeepReadonly<GetVoiceSettingsParameters>
    ): ServiceOperationQueryKey<GetVoiceSettingsSchema, GetVoiceSettingsParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get
     * @description Get complete voice settings for an office with all subsections
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.voiceSettingsService.getVoiceSettings.useQuery({
     *     path: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetVoiceSettingsData>(
      parameters:
        | ServiceOperationQueryKey<GetVoiceSettingsSchema, GetVoiceSettingsParameters>
        | DeepReadonly<GetVoiceSettingsParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          GetVoiceSettingsData,
          GetVoiceSettingsError,
          TData,
          ServiceOperationQueryKey<GetVoiceSettingsSchema, GetVoiceSettingsParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetVoiceSettingsError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get
     * @description Get complete voice settings for an office with all subsections
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.voiceSettingsService.getVoiceSettings.useQuery({
     *     path: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetVoiceSettingsData>(
      parameters:
        | ServiceOperationQueryKey<GetVoiceSettingsSchema, GetVoiceSettingsParameters>
        | DeepReadonly<GetVoiceSettingsParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          GetVoiceSettingsData,
          GetVoiceSettingsError,
          TData,
          ServiceOperationQueryKey<GetVoiceSettingsSchema, GetVoiceSettingsParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetVoiceSettingsError>>;
    /**
     * @summary Get
     * @description Get complete voice settings for an office with all subsections
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetVoiceSettingsParameters>
    ): ServiceOperationInfiniteQueryKey<GetVoiceSettingsSchema, GetVoiceSettingsParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get
     * @description Get complete voice settings for an office with all subsections
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.voiceSettingsService.getVoiceSettings.useInfiniteQuery({
     *     path: {
     *         office_id: officeId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetVoiceSettingsParameters,
      TQueryFnData = GetVoiceSettingsData,
      TData = OperationInfiniteData<TQueryFnData, GetVoiceSettingsParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetVoiceSettingsSchema, GetVoiceSettingsParameters>
        | DeepReadonly<GetVoiceSettingsParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetVoiceSettingsError,
          TData,
          ServiceOperationInfiniteQueryKey<GetVoiceSettingsSchema, GetVoiceSettingsParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetVoiceSettingsError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get
     * @description Get complete voice settings for an office with all subsections
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.voiceSettingsService.getVoiceSettings.useInfiniteQuery({
     *     path: {
     *         office_id: officeId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetVoiceSettingsParameters,
      TQueryFnData = GetVoiceSettingsData,
      TData = OperationInfiniteData<TQueryFnData, GetVoiceSettingsParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetVoiceSettingsSchema, GetVoiceSettingsParameters>
        | DeepReadonly<GetVoiceSettingsParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetVoiceSettingsError,
          TData,
          ServiceOperationInfiniteQueryKey<GetVoiceSettingsSchema, GetVoiceSettingsParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetVoiceSettingsData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetVoiceSettingsError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get
     * @description Get complete voice settings for an office with all subsections
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getVoiceSettingsTotal = qraft.voiceSettingsService.getVoiceSettings.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getVoiceSettingsByParametersTotal = qraft.voiceSettingsService.getVoiceSettings.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             office_id: officeId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetVoiceSettingsSchema,
            GetVoiceSettingsData,
            TInfinite,
            GetVoiceSettingsParameters,
            GetVoiceSettingsError
          >
        | QueryFiltersByQueryKey<
            GetVoiceSettingsSchema,
            GetVoiceSettingsData,
            TInfinite,
            GetVoiceSettingsParameters,
            GetVoiceSettingsError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get
     * @description Get complete voice settings for an office with all subsections
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getVoiceSettingsResults = qraft.voiceSettingsService.getVoiceSettings.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             path: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * getVoiceSettingsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getVoiceSettingsCombinedResults = qraft.voiceSettingsService.getVoiceSettings.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             path: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * getVoiceSettingsCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetVoiceSettingsSchema,
          GetVoiceSettingsParameters,
          GetVoiceSettingsData,
          GetVoiceSettingsError
        >
      >,
      TCombinedResult = Array<UseQueryResult<GetVoiceSettingsData, GetVoiceSettingsError>>,
    >(options: {
      queries: T;
      combine?: (results: Array<UseQueryResult<GetVoiceSettingsData, GetVoiceSettingsError>>) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get
     * @description Get complete voice settings for an office with all subsections
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.voiceSettingsService.getVoiceSettings.useSuspenseQuery({
     *     path: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetVoiceSettingsData>(
      parameters:
        | ServiceOperationQueryKey<GetVoiceSettingsSchema, GetVoiceSettingsParameters>
        | DeepReadonly<GetVoiceSettingsParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          GetVoiceSettingsData,
          GetVoiceSettingsError,
          TData,
          ServiceOperationQueryKey<GetVoiceSettingsSchema, GetVoiceSettingsParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetVoiceSettingsError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get
     * @description Get complete voice settings for an office with all subsections
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.voiceSettingsService.getVoiceSettings.useSuspenseInfiniteQuery({
     *     path: {
     *         office_id: officeId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends GetVoiceSettingsParameters, TData = GetVoiceSettingsData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetVoiceSettingsSchema, GetVoiceSettingsParameters>
        | DeepReadonly<GetVoiceSettingsParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetVoiceSettingsData,
          GetVoiceSettingsError,
          OperationInfiniteData<TData, GetVoiceSettingsParameters>,
          ServiceOperationInfiniteQueryKey<GetVoiceSettingsSchema, GetVoiceSettingsParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetVoiceSettingsData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetVoiceSettingsParameters>,
      OperationError<GetVoiceSettingsError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get
     * @description Get complete voice settings for an office with all subsections
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getVoiceSettingsData = qraft.voiceSettingsService.getVoiceSettings.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             path: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * getVoiceSettingsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getVoiceSettingsCombinedData = qraft.voiceSettingsService.getVoiceSettings.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             path: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * getVoiceSettingsCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetVoiceSettingsSchema,
          GetVoiceSettingsParameters,
          GetVoiceSettingsData,
          GetVoiceSettingsError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<GetVoiceSettingsData, GetVoiceSettingsError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<WithOptional<UseSuspenseQueryResult<GetVoiceSettingsData, GetVoiceSettingsError>, 'data'>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Get
     * @description Get complete voice settings for an office with all subsections
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetVoiceSettingsSchema,
        GetVoiceSettingsData,
        GetVoiceSettingsParameters,
        GetVoiceSettingsError
      >
    ): Promise<GetVoiceSettingsData>;
    /**
     * @summary Get
     * @description Get complete voice settings for an office with all subsections
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetVoiceSettingsSchema,
        GetVoiceSettingsData,
        GetVoiceSettingsParameters,
        GetVoiceSettingsError
      >
    ): Promise<void>;
    /**
     * @summary Get
     * @description Get complete voice settings for an office with all subsections
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetVoiceSettingsSchema,
        GetVoiceSettingsData,
        GetVoiceSettingsParameters,
        GetVoiceSettingsError
      >
    ): Promise<GetVoiceSettingsData>;
    /**
     * @summary Get
     * @description Get complete voice settings for an office with all subsections
     */
    fetchInfiniteQuery<TPageParam extends GetVoiceSettingsParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetVoiceSettingsSchema,
        GetVoiceSettingsData,
        GetVoiceSettingsParameters,
        DeepReadonly<TPageParam>,
        GetVoiceSettingsError
      >
    ): Promise<OperationInfiniteData<GetVoiceSettingsData, GetVoiceSettingsParameters>>;
    /**
     * @summary Get
     * @description Get complete voice settings for an office with all subsections
     */
    prefetchInfiniteQuery<TPageParam extends GetVoiceSettingsParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetVoiceSettingsSchema,
        GetVoiceSettingsData,
        GetVoiceSettingsParameters,
        DeepReadonly<TPageParam>,
        GetVoiceSettingsError
      >
    ): Promise<void>;
    /**
     * @summary Get
     * @description Get complete voice settings for an office with all subsections
     */
    ensureInfiniteQueryData<TPageParam extends GetVoiceSettingsParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetVoiceSettingsSchema,
        GetVoiceSettingsData,
        GetVoiceSettingsParameters,
        DeepReadonly<TPageParam>,
        GetVoiceSettingsError
      >
    ): Promise<OperationInfiniteData<GetVoiceSettingsData, GetVoiceSettingsParameters>>;
    /**
     * @summary Get
     * @description Get complete voice settings for an office with all subsections
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<GetVoiceSettingsSchema, GetVoiceSettingsParameters>
        | DeepReadonly<GetVoiceSettingsParameters>
    ): GetVoiceSettingsData | undefined;
    /**
     * @summary Get
     * @description Get complete voice settings for an office with all subsections
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetVoiceSettingsSchema, GetVoiceSettingsParameters>
        | DeepReadonly<GetVoiceSettingsParameters>
    ): OperationInfiniteData<GetVoiceSettingsData, GetVoiceSettingsParameters> | undefined;
    /**
     * @summary Get
     * @description Get complete voice settings for an office with all subsections
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetVoiceSettingsSchema,
            GetVoiceSettingsData,
            TInfinite,
            GetVoiceSettingsParameters,
            GetVoiceSettingsError
          >
        | QueryFiltersByQueryKey<
            GetVoiceSettingsSchema,
            GetVoiceSettingsData,
            TInfinite,
            GetVoiceSettingsParameters,
            GetVoiceSettingsError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<GetVoiceSettingsSchema, GetVoiceSettingsParameters>,
            data: NoInfer<OperationInfiniteData<GetVoiceSettingsData, GetVoiceSettingsParameters>> | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<GetVoiceSettingsSchema, GetVoiceSettingsParameters>,
            data: GetVoiceSettingsData | undefined,
          ]
        >;
    /**
     * @summary Get
     * @description Get complete voice settings for an office with all subsections
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<GetVoiceSettingsSchema, GetVoiceSettingsParameters>
        | DeepReadonly<GetVoiceSettingsParameters>
    ): QueryState<GetVoiceSettingsData, GetVoiceSettingsError> | undefined;
    /**
     * @summary Get
     * @description Get complete voice settings for an office with all subsections
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetVoiceSettingsParameters>
        | ServiceOperationInfiniteQueryKey<GetVoiceSettingsSchema, GetVoiceSettingsParameters>
    ):
      | QueryState<OperationInfiniteData<GetVoiceSettingsData, GetVoiceSettingsParameters>, GetVoiceSettingsError>
      | undefined;
    /**
     * @summary Get
     * @description Get complete voice settings for an office with all subsections
     */
    setQueryData(
      parameters:
        | DeepReadonly<GetVoiceSettingsParameters>
        | ServiceOperationQueryKey<GetVoiceSettingsSchema, GetVoiceSettingsParameters>,
      updater: Updater<
        NoInfer<GetVoiceSettingsData> | undefined,
        NoInfer<DeepReadonly<GetVoiceSettingsData>> | undefined
      >,
      options?: SetDataOptions
    ): GetVoiceSettingsData | undefined;
    /**
     * @summary Get
     * @description Get complete voice settings for an office with all subsections
     */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<GetVoiceSettingsParameters>
        | ServiceOperationInfiniteQueryKey<GetVoiceSettingsSchema, GetVoiceSettingsParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<GetVoiceSettingsData, GetVoiceSettingsParameters>> | undefined,
        NoInfer<DeepReadonly<OperationInfiniteData<GetVoiceSettingsData, GetVoiceSettingsParameters>>> | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<GetVoiceSettingsData, GetVoiceSettingsParameters> | undefined;
    /**
     * @summary Get
     * @description Get complete voice settings for an office with all subsections
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetVoiceSettingsSchema,
            GetVoiceSettingsData,
            TInfinite,
            GetVoiceSettingsParameters,
            GetVoiceSettingsError
          >
        | QueryFiltersByQueryKey<
            GetVoiceSettingsSchema,
            GetVoiceSettingsData,
            TInfinite,
            GetVoiceSettingsParameters,
            GetVoiceSettingsError
          >,
      updater: Updater<NoInfer<GetVoiceSettingsData> | undefined, NoInfer<GetVoiceSettingsData> | undefined>,
      options?: SetDataOptions
    ): Array<GetVoiceSettingsData | undefined>;
    /**
     * @summary Get
     * @description Get complete voice settings for an office with all subsections
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetVoiceSettingsSchema,
        GetVoiceSettingsData,
        TInfinite,
        GetVoiceSettingsParameters,
        GetVoiceSettingsError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Get
     * @description Get complete voice settings for an office with all subsections
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetVoiceSettingsSchema,
            GetVoiceSettingsData,
            TInfinite,
            GetVoiceSettingsParameters,
            GetVoiceSettingsError
          >
        | QueryFiltersByQueryKey<
            GetVoiceSettingsSchema,
            GetVoiceSettingsData,
            TInfinite,
            GetVoiceSettingsParameters,
            GetVoiceSettingsError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Get
     * @description Get complete voice settings for an office with all subsections
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetVoiceSettingsSchema,
            GetVoiceSettingsData,
            TInfinite,
            GetVoiceSettingsParameters,
            GetVoiceSettingsError
          >
        | QueryFiltersByQueryKey<
            GetVoiceSettingsSchema,
            GetVoiceSettingsData,
            TInfinite,
            GetVoiceSettingsParameters,
            GetVoiceSettingsError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Get
     * @description Get complete voice settings for an office with all subsections
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetVoiceSettingsSchema,
            GetVoiceSettingsData,
            TInfinite,
            GetVoiceSettingsParameters,
            GetVoiceSettingsError
          >
        | QueryFiltersByQueryKey<
            GetVoiceSettingsSchema,
            GetVoiceSettingsData,
            TInfinite,
            GetVoiceSettingsParameters,
            GetVoiceSettingsError
          >
    ): void;
    /**
     * @summary Get
     * @description Get complete voice settings for an office with all subsections
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetVoiceSettingsSchema,
            GetVoiceSettingsData,
            TInfinite,
            GetVoiceSettingsParameters,
            GetVoiceSettingsError
          >
        | QueryFiltersByQueryKey<
            GetVoiceSettingsSchema,
            GetVoiceSettingsData,
            TInfinite,
            GetVoiceSettingsParameters,
            GetVoiceSettingsError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Get
     * @description Get complete voice settings for an office with all subsections
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetVoiceSettingsSchema,
            GetVoiceSettingsData,
            TInfinite,
            GetVoiceSettingsParameters,
            GetVoiceSettingsError
          >
        | QueryFiltersByQueryKey<
            GetVoiceSettingsSchema,
            GetVoiceSettingsData,
            TInfinite,
            GetVoiceSettingsParameters,
            GetVoiceSettingsError
          >
    ): number;
    schema: GetVoiceSettingsSchema;
    types: {
      parameters: GetVoiceSettingsParameters;
      data: GetVoiceSettingsData;
      error: GetVoiceSettingsError;
    };
  };
  /**
   * @summary Update
   * @description Update partial office voice settings - only provided fields will be updated
   */
  updateVoiceSettings: {
    /**
     * @summary Update
     * @description Update partial office voice settings - only provided fields will be updated
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        UpdateVoiceSettingsBody,
        UpdateVoiceSettingsParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: UpdateVoiceSettingsSchema,
        options: ServiceOperationMutationFnOptions<
          UpdateVoiceSettingsBody,
          UpdateVoiceSettingsParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<UpdateVoiceSettingsData, UpdateVoiceSettingsError>>
    ): Promise<RequestFnResponse<UpdateVoiceSettingsData, UpdateVoiceSettingsError>>;
    /**
     * @summary Update
     * @description Update partial office voice settings - only provided fields will be updated
     */
    getMutationKey(
      parameters: DeepReadonly<UpdateVoiceSettingsParameters> | void
    ): ServiceOperationMutationKey<UpdateVoiceSettingsSchema, UpdateVoiceSettingsParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @description Update partial office voice settings - only provided fields will be updated
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.voiceSettingsService.updateVoiceSettings.useMutation({
     *     path: {
     *         office_id: officeId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.voiceSettingsService.updateVoiceSettings.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         office_id: officeId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends UpdateVoiceSettingsBody, TContext = unknown>(
      parameters: DeepReadonly<UpdateVoiceSettingsParameters>,
      options?: ServiceOperationUseMutationOptions<
        UpdateVoiceSettingsSchema,
        UpdateVoiceSettingsData,
        UpdateVoiceSettingsParameters,
        TVariables,
        OperationError<UpdateVoiceSettingsError>,
        TContext
      >
    ): UseMutationResult<UpdateVoiceSettingsData, OperationError<UpdateVoiceSettingsError>, TVariables, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @description Update partial office voice settings - only provided fields will be updated
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.voiceSettingsService.updateVoiceSettings.useMutation({
     *     path: {
     *         office_id: officeId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.voiceSettingsService.updateVoiceSettings.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         office_id: officeId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<UpdateVoiceSettingsBody, UpdateVoiceSettingsParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        UpdateVoiceSettingsSchema,
        UpdateVoiceSettingsData,
        UpdateVoiceSettingsParameters,
        TVariables,
        OperationError<UpdateVoiceSettingsError>,
        TContext
      >
    ): UseMutationResult<UpdateVoiceSettingsData, OperationError<UpdateVoiceSettingsError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Update
     * @description Update partial office voice settings - only provided fields will be updated
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const updateVoiceSettingsTotal = qraft.voiceSettingsService.updateVoiceSettings.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const updateVoiceSettingsTotal = qraft.voiceSettingsService.updateVoiceSettings.useIsMutating({
     *     parameters: {
     *         path: {
     *             office_id: officeId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            UpdateVoiceSettingsBody,
            UpdateVoiceSettingsData,
            UpdateVoiceSettingsParameters,
            OperationError<UpdateVoiceSettingsError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateVoiceSettingsSchema,
            UpdateVoiceSettingsBody,
            UpdateVoiceSettingsData,
            UpdateVoiceSettingsParameters,
            OperationError<UpdateVoiceSettingsError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Update
     * @description Update partial office voice settings - only provided fields will be updated
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const updateVoiceSettingsPendingMutationVariables = qraft.voiceSettingsService.updateVoiceSettings.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const updateVoiceSettingsMutationData = qraft.voiceSettingsService.updateVoiceSettings.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 office_id: officeId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        UpdateVoiceSettingsData,
        OperationError<UpdateVoiceSettingsError>,
        MutationVariables<UpdateVoiceSettingsBody, UpdateVoiceSettingsParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            UpdateVoiceSettingsBody,
            UpdateVoiceSettingsData,
            UpdateVoiceSettingsParameters,
            OperationError<UpdateVoiceSettingsError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateVoiceSettingsSchema,
            UpdateVoiceSettingsBody,
            UpdateVoiceSettingsData,
            UpdateVoiceSettingsParameters,
            OperationError<UpdateVoiceSettingsError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          UpdateVoiceSettingsData,
          OperationError<UpdateVoiceSettingsError>,
          MutationVariables<UpdateVoiceSettingsBody, UpdateVoiceSettingsParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Update
     * @description Update partial office voice settings - only provided fields will be updated
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            UpdateVoiceSettingsBody,
            UpdateVoiceSettingsData,
            UpdateVoiceSettingsParameters,
            OperationError<UpdateVoiceSettingsError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateVoiceSettingsSchema,
            UpdateVoiceSettingsBody,
            UpdateVoiceSettingsData,
            UpdateVoiceSettingsParameters,
            OperationError<UpdateVoiceSettingsError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Update
     * @description Update partial office voice settings - only provided fields will be updated
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.voiceSettingsService.updateVoiceSettings.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             office_id: officeId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.voiceSettingsService.updateVoiceSettings.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              UpdateVoiceSettingsBody,
              UpdateVoiceSettingsData,
              UpdateVoiceSettingsParameters,
              OperationError<UpdateVoiceSettingsError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateVoiceSettingsSchema,
              UpdateVoiceSettingsBody,
              UpdateVoiceSettingsData,
              UpdateVoiceSettingsParameters,
              OperationError<UpdateVoiceSettingsError>,
              TContext
            >
      ):
        | Mutation<
            UpdateVoiceSettingsData,
            UpdateVoiceSettingsError,
            MutationVariables<UpdateVoiceSettingsBody, UpdateVoiceSettingsParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              UpdateVoiceSettingsBody,
              UpdateVoiceSettingsData,
              UpdateVoiceSettingsParameters,
              OperationError<UpdateVoiceSettingsError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateVoiceSettingsSchema,
              UpdateVoiceSettingsBody,
              UpdateVoiceSettingsData,
              UpdateVoiceSettingsParameters,
              OperationError<UpdateVoiceSettingsError>,
              TContext
            >
      ): Array<
        Mutation<
          UpdateVoiceSettingsData,
          UpdateVoiceSettingsError,
          MutationVariables<UpdateVoiceSettingsBody, UpdateVoiceSettingsParameters>,
          TContext
        >
      >;
    };
    schema: UpdateVoiceSettingsSchema;
    types: {
      parameters: UpdateVoiceSettingsParameters;
      data: UpdateVoiceSettingsData;
      error: UpdateVoiceSettingsError;
      body: UpdateVoiceSettingsBody;
    };
  };
  /**
   * @summary Get All Voice Settings
   * @description Get all voice settings for an office - useful for debugging
   */
  getAllVoiceSettingsVoiceSettingsAllOfficeIdGet: {
    /**
     * @summary Get All Voice Settings
     * @description Get all voice settings for an office - useful for debugging
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters,
            TMeta,
            TSignal
          >
        | QueryFnOptionsByParameters<GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters, TMeta, TSignal>,
      client?: (
        schema: GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema,
        options: {
          parameters: GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<
        RequestFnResponse<
          GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData,
          GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetError
        >
      >
    ): Promise<
      RequestFnResponse<
        GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData,
        GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetError
      >
    >;
    /**
     * @summary Get All Voice Settings
     * @description Get all voice settings for an office - useful for debugging
     */
    getQueryKey(
      parameters: DeepReadonly<GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters>
    ): ServiceOperationQueryKey<
      GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema,
      GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get All Voice Settings
     * @description Get all voice settings for an office - useful for debugging
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.voiceSettingsService.getAllVoiceSettingsVoiceSettingsAllOfficeIdGet.useQuery({
     *     path: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters
          >
        | DeepReadonly<GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData,
          GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetError,
          TData,
          ServiceOperationQueryKey<
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get All Voice Settings
     * @description Get all voice settings for an office - useful for debugging
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.voiceSettingsService.getAllVoiceSettingsVoiceSettingsAllOfficeIdGet.useQuery({
     *     path: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters
          >
        | DeepReadonly<GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData,
          GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetError,
          TData,
          ServiceOperationQueryKey<
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetError>>;
    /**
     * @summary Get All Voice Settings
     * @description Get all voice settings for an office - useful for debugging
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters>
    ): ServiceOperationInfiniteQueryKey<
      GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema,
      GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get All Voice Settings
     * @description Get all voice settings for an office - useful for debugging
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.voiceSettingsService.getAllVoiceSettingsVoiceSettingsAllOfficeIdGet.useInfiniteQuery({
     *     path: {
     *         office_id: officeId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters,
      TQueryFnData = GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData,
      TData = OperationInfiniteData<TQueryFnData, GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters
          >
        | DeepReadonly<GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get All Voice Settings
     * @description Get all voice settings for an office - useful for debugging
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.voiceSettingsService.getAllVoiceSettingsVoiceSettingsAllOfficeIdGet.useInfiniteQuery({
     *     path: {
     *         office_id: officeId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters,
      TQueryFnData = GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData,
      TData = OperationInfiniteData<TQueryFnData, GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters
          >
        | DeepReadonly<GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get All Voice Settings
     * @description Get all voice settings for an office - useful for debugging
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getAllVoiceSettingsVoiceSettingsAllOfficeIdGetTotal = qraft.voiceSettingsService.getAllVoiceSettingsVoiceSettingsAllOfficeIdGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getAllVoiceSettingsVoiceSettingsAllOfficeIdGetByParametersTotal = qraft.voiceSettingsService.getAllVoiceSettingsVoiceSettingsAllOfficeIdGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             office_id: officeId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData,
            TInfinite,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetError
          >
        | QueryFiltersByQueryKey<
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData,
            TInfinite,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get All Voice Settings
     * @description Get all voice settings for an office - useful for debugging
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getAllVoiceSettingsVoiceSettingsAllOfficeIdGetResults = qraft.voiceSettingsService.getAllVoiceSettingsVoiceSettingsAllOfficeIdGet.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             path: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * getAllVoiceSettingsVoiceSettingsAllOfficeIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getAllVoiceSettingsVoiceSettingsAllOfficeIdGetCombinedResults = qraft.voiceSettingsService.getAllVoiceSettingsVoiceSettingsAllOfficeIdGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             path: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * getAllVoiceSettingsVoiceSettingsAllOfficeIdGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema,
          GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters,
          GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData,
          GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<
          GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData,
          GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          UseQueryResult<
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetError
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get All Voice Settings
     * @description Get all voice settings for an office - useful for debugging
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.voiceSettingsService.getAllVoiceSettingsVoiceSettingsAllOfficeIdGet.useSuspenseQuery({
     *     path: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters
          >
        | DeepReadonly<GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData,
          GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetError,
          TData,
          ServiceOperationQueryKey<
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get All Voice Settings
     * @description Get all voice settings for an office - useful for debugging
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.voiceSettingsService.getAllVoiceSettingsVoiceSettingsAllOfficeIdGet.useSuspenseInfiniteQuery({
     *     path: {
     *         office_id: officeId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters,
      TData = GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters
          >
        | DeepReadonly<GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData,
          GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetError,
          OperationInfiniteData<TData, GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters>,
          ServiceOperationInfiniteQueryKey<
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters>,
      OperationError<GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get All Voice Settings
     * @description Get all voice settings for an office - useful for debugging
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getAllVoiceSettingsVoiceSettingsAllOfficeIdGetData = qraft.voiceSettingsService.getAllVoiceSettingsVoiceSettingsAllOfficeIdGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             path: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * getAllVoiceSettingsVoiceSettingsAllOfficeIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getAllVoiceSettingsVoiceSettingsAllOfficeIdGetCombinedData = qraft.voiceSettingsService.getAllVoiceSettingsVoiceSettingsAllOfficeIdGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             path: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * getAllVoiceSettingsVoiceSettingsAllOfficeIdGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema,
          GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters,
          GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData,
          GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<
          GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData,
          GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<
              GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData,
              GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetError
            >,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Get All Voice Settings
     * @description Get all voice settings for an office - useful for debugging
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema,
        GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData,
        GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters,
        GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetError
      >
    ): Promise<GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData>;
    /**
     * @summary Get All Voice Settings
     * @description Get all voice settings for an office - useful for debugging
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema,
        GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData,
        GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters,
        GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetError
      >
    ): Promise<void>;
    /**
     * @summary Get All Voice Settings
     * @description Get all voice settings for an office - useful for debugging
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema,
        GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData,
        GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters,
        GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetError
      >
    ): Promise<GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData>;
    /**
     * @summary Get All Voice Settings
     * @description Get all voice settings for an office - useful for debugging
     */
    fetchInfiniteQuery<TPageParam extends GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema,
        GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData,
        GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters,
        DeepReadonly<TPageParam>,
        GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetError
      >
    ): Promise<
      OperationInfiniteData<
        GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData,
        GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters
      >
    >;
    /**
     * @summary Get All Voice Settings
     * @description Get all voice settings for an office - useful for debugging
     */
    prefetchInfiniteQuery<TPageParam extends GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema,
        GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData,
        GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters,
        DeepReadonly<TPageParam>,
        GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetError
      >
    ): Promise<void>;
    /**
     * @summary Get All Voice Settings
     * @description Get all voice settings for an office - useful for debugging
     */
    ensureInfiniteQueryData<TPageParam extends GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema,
        GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData,
        GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters,
        DeepReadonly<TPageParam>,
        GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetError
      >
    ): Promise<
      OperationInfiniteData<
        GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData,
        GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters
      >
    >;
    /**
     * @summary Get All Voice Settings
     * @description Get all voice settings for an office - useful for debugging
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters
          >
        | DeepReadonly<GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters>
    ): GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData | undefined;
    /**
     * @summary Get All Voice Settings
     * @description Get all voice settings for an office - useful for debugging
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters
          >
        | DeepReadonly<GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters>
    ):
      | OperationInfiniteData<
          GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData,
          GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters
        >
      | undefined;
    /**
     * @summary Get All Voice Settings
     * @description Get all voice settings for an office - useful for debugging
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData,
            TInfinite,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetError
          >
        | QueryFiltersByQueryKey<
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData,
            TInfinite,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema,
              GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData,
                    GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema,
              GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters
            >,
            data: GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData | undefined,
          ]
        >;
    /**
     * @summary Get All Voice Settings
     * @description Get all voice settings for an office - useful for debugging
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters
          >
        | DeepReadonly<GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters>
    ):
      | QueryState<
          GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData,
          GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetError
        >
      | undefined;
    /**
     * @summary Get All Voice Settings
     * @description Get all voice settings for an office - useful for debugging
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters
          >
    ):
      | QueryState<
          OperationInfiniteData<
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters
          >,
          GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetError
        >
      | undefined;
    /**
     * @summary Get All Voice Settings
     * @description Get all voice settings for an office - useful for debugging
     */
    setQueryData(
      parameters:
        | DeepReadonly<GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters>
        | ServiceOperationQueryKey<
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters
          >,
      updater: Updater<
        NoInfer<GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData> | undefined,
        NoInfer<DeepReadonly<GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData | undefined;
    /**
     * @summary Get All Voice Settings
     * @description Get all voice settings for an office - useful for debugging
     */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<
              GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData,
              GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters
            >
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData,
                GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<
          GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData,
          GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters
        >
      | undefined;
    /**
     * @summary Get All Voice Settings
     * @description Get all voice settings for an office - useful for debugging
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData,
            TInfinite,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetError
          >
        | QueryFiltersByQueryKey<
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData,
            TInfinite,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetError
          >,
      updater: Updater<
        NoInfer<GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData> | undefined,
        NoInfer<GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData | undefined>;
    /**
     * @summary Get All Voice Settings
     * @description Get all voice settings for an office - useful for debugging
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema,
        GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData,
        TInfinite,
        GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters,
        GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Get All Voice Settings
     * @description Get all voice settings for an office - useful for debugging
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData,
            TInfinite,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetError
          >
        | QueryFiltersByQueryKey<
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData,
            TInfinite,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Get All Voice Settings
     * @description Get all voice settings for an office - useful for debugging
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData,
            TInfinite,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetError
          >
        | QueryFiltersByQueryKey<
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData,
            TInfinite,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Get All Voice Settings
     * @description Get all voice settings for an office - useful for debugging
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData,
            TInfinite,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetError
          >
        | QueryFiltersByQueryKey<
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData,
            TInfinite,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetError
          >
    ): void;
    /**
     * @summary Get All Voice Settings
     * @description Get all voice settings for an office - useful for debugging
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData,
            TInfinite,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetError
          >
        | QueryFiltersByQueryKey<
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData,
            TInfinite,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Get All Voice Settings
     * @description Get all voice settings for an office - useful for debugging
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData,
            TInfinite,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetError
          >
        | QueryFiltersByQueryKey<
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData,
            TInfinite,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters,
            GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetError
          >
    ): number;
    schema: GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema;
    types: {
      parameters: GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters;
      data: GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData;
      error: GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetError;
    };
  };
}
/**
 * @summary Get
 * @description Get complete voice settings for an office with all subsections
 */
export const getVoiceSettings = {
  schema: {
    method: 'get',
    url: '/voice_settings/office/{office_id}',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetVoiceSettingsSchema;
  [QraftServiceOperationsToken]: VoiceSettingsService['getVoiceSettings'];
};
/**
 * @summary Update
 * @description Update partial office voice settings - only provided fields will be updated
 */
export const updateVoiceSettings = {
  schema: {
    method: 'patch',
    url: '/voice_settings/office/{office_id}',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: UpdateVoiceSettingsSchema;
  [QraftServiceOperationsToken]: VoiceSettingsService['updateVoiceSettings'];
};
/**
 * @summary Get All Voice Settings
 * @description Get all voice settings for an office - useful for debugging
 */
export const getAllVoiceSettingsVoiceSettingsAllOfficeIdGet = {
  schema: {
    method: 'get',
    url: '/voice_settings/all/{office_id}',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema;
  [QraftServiceOperationsToken]: VoiceSettingsService['getAllVoiceSettingsVoiceSettingsAllOfficeIdGet'];
};
export const voiceSettingsService = {
  getVoiceSettings,
  updateVoiceSettings,
  getAllVoiceSettingsVoiceSettingsAllOfficeIdGet,
} as const;
type GetVoiceSettingsSchema = {
  method: 'get';
  url: '/voice_settings/office/{office_id}';
  security: ['HTTPBearer'];
};
type GetVoiceSettingsParameters = paths['/voice_settings/office/{office_id}']['get']['parameters'];
type GetVoiceSettingsData =
  paths['/voice_settings/office/{office_id}']['get']['responses']['200']['content']['application/json'];
type GetVoiceSettingsError =
  paths['/voice_settings/office/{office_id}']['get']['responses']['422']['content']['application/json'];
type UpdateVoiceSettingsSchema = {
  method: 'patch';
  url: '/voice_settings/office/{office_id}';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type UpdateVoiceSettingsParameters = paths['/voice_settings/office/{office_id}']['patch']['parameters'];
type UpdateVoiceSettingsData =
  paths['/voice_settings/office/{office_id}']['patch']['responses']['200']['content']['application/json'];
type UpdateVoiceSettingsError =
  paths['/voice_settings/office/{office_id}']['patch']['responses']['422']['content']['application/json'];
type UpdateVoiceSettingsBody =
  paths['/voice_settings/office/{office_id}']['patch']['requestBody']['content']['application/json'];
type GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetSchema = {
  method: 'get';
  url: '/voice_settings/all/{office_id}';
  security: ['HTTPBearer'];
};
type GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetParameters =
  paths['/voice_settings/all/{office_id}']['get']['parameters'];
type GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetData =
  paths['/voice_settings/all/{office_id}']['get']['responses']['200']['content']['application/json'];
type GetAllVoiceSettingsVoiceSettingsAllOfficeIdGetError =
  paths['/voice_settings/all/{office_id}']['get']['responses']['422']['content']['application/json'];
